import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';

type LoadingIndicatorProps = {
  type?: 'bar' | 'spinner' | 'logo';
  color?: string;
  size?: 'small' | 'medium' | 'large';
  text?: string;
  fullScreen?: boolean;
};

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  type = 'spinner',
  color = '#34A853', // Default to green color to match brand
  size = 'medium',
  text,
  fullScreen = false,
}) => {
  const [barProgress, setBarProgress] = useState(0);

  // For the progress bar animation
  useEffect(() => {
    if (type === 'bar') {
      const interval = setInterval(() => {
        setBarProgress((prev) => {
          // Make it seem like it's loading by increasing faster at first, then slowing down
          const increment = Math.max(0.5, 10 * (1 - prev / 100));
          const newValue = prev + increment;
          return newValue >= 100 ? 0 : newValue;
        });
      }, 100);

      return () => clearInterval(interval);
    }
  }, [type]);

  const containerClass = fullScreen
    ? styles.fullScreenContainer
    : styles.container;

  return (
    <div className={`${containerClass} ${styles[size]}`}>
      {type === 'bar' && (
        <div className={styles.barContainer}>
          <div
            className={styles.bar}
            style={{
              width: `${barProgress}%`,
              backgroundColor: color,
            }}
          />
        </div>
      )}

      {type === 'spinner' && (
        <div className={styles.spinnerContainer}>
          <div className={styles.spinner} style={{ borderTopColor: color }} />
        </div>
      )}

      {type === 'logo' && (
        <div className={styles.logoContainer}>
          <div className={styles.bellWrapper}>
            <div className={styles.bell} />
          </div>
        </div>
      )}

      {text && <div className={styles.text}>{text}</div>}
    </div>
  );
};

export default LoadingIndicator;
